import { AbstractControl, ValidationErrors } from '@angular/forms';
export function passwordHasDigit(control: AbstractControl): ValidationErrors | null {
  const value = control.value || '';
  if (!/\d/.test(value)) {
    return { noDigit: true };
  }
  return null;
}

export function passwordHasUppercase(control: AbstractControl): ValidationErrors | null {
  const value = control.value || '';
  if (!/[A-Z]/.test(value)) {
    return { noUppercase: true };
  }
  return null;
}

export function passwordHasLowercase(control: AbstractControl): ValidationErrors | null {
  const value = control.value || '';
  if (!/[a-z]/.test(value)) {
    return { noLowercase: true };
  }
  return null;
}

export function passwordHasSpecialChar(control: AbstractControl): ValidationErrors | null {
  const value = control.value || '';
  // The regex checks for any character in the provided set
  if (!/[!#§$%&*+,-./:;<=>?@[^_`{|}~()'"\\]/.test(value)) {
    return { noSpecialChar: true };
  }
  return null;
}

export function passwordHasWhitespace(control: AbstractControl): ValidationErrors | null {
  const value = control.value || '';
  if (/\s/.test(value)) {
    return { hasWhitespace: true };
  }
  return null;
}
